"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const applications = [{
  id: 1,
  title: "Strategic Logistics & Supply",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596514/img/app_energy_storage.png",
  span: "md:col-span-7"
}, {
  id: 2,
  title: "Global Workforce Solutions",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596514/img/app_advanced_composites.png",
  span: "md:col-span-5"
}, {
  id: 3,
  title: "Operational Excellence",
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/IMG-20220207-WA0023.jpg?v=eij7yqjp32o",
  span: "md:col-span-5"
}, {
  id: 4,
  title: "Scalable Infrastructure",
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/20240819_134444-scaled.jpg?v=mq7wtplzmih",
  span: "md:col-span-7"
}];
function GalleryItem({
  app,
  index
}: {
  app: (typeof applications)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <div data-section-id="127134" ref={ref} data-index={index} className={`group relative overflow-hidden rounded-[4px] ${app.span} transition-all duration-700 ease-out shadow-xl ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <AspectRatio ratio={16 / 9}>
        {}
        
        
        {}
        <div className="absolute inset-0 bg-primary/10 pointer-events-none transition-opacity duration-500 group-hover:opacity-0" />

        {}
        
      </AspectRatio>
    </div>;
}
export default function ApplicationAreas() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section id="visual-framework" className="py-24 bg-background dark">
      
    </section>;
}